import { PixiFiber, createPortal, injectDevtools } from './reconciler'
import { registerElement } from './utils/element'

const { createContainer, updateContainer, flushSync } = PixiFiber

const noop = () => {}

const createRootContainer = (container, layouter = noop, renderer = noop) => {
  return {
    layouter,
    renderer,
    fiberRoot: createContainer(container),
  }
}

export default {
  render(element, container, options = {}) {
    let root = container._reactPixiRoot
    if (!root) {
      // Initial mount
      root = container._reactPixiRoot = createRootContainer(
        container,
        options.layouter,
        options.renderer,
      )
      // Initial mount should not be batched.
      flushSync(() => {
        updateContainer(element, root.fiberRoot)
      })
    } else {
      if (process.env.ENABLE_BUILDER_DEVTOOLS) {
        injectDevtools()
      }
      // Update
      updateContainer(element, root.fiberRoot)
    }
  },

  registerElement(type, createInstance) {
    return registerElement(type, createInstance)
  },

  createPortal(children, container, implementation, key) {
    return createPortal(children, container, implementation, key)
  },
}
